import React from "react";
import RoutingPaths from "helper/routingPath";
import "./index.css";
import packageJson from '../../../package.json';

function Footer() {  

const currentVersion = packageJson.version;


  return (
    <footer className="footer__div">
      <div className="footer__left">
        <a
          href={RoutingPaths.home}
          rel="noopener noreferrer"
          className="footer__brand-link"
        >
          StudyGram v{currentVersion}
        </a>
      </div>
      <div className="footer__right">
        <span className="footer__powered-text">Powered by</span>
        <a
          href="https://vyzioninnovations.com/"
          target="_blank"
          rel="noopener noreferrer"
          className="anchor__hover"
        >
          Vyzion &amp; Innovations
        </a>
      </div>
    </footer>
  );
}

export default Footer;
